import { useState } from "react";
import { Copy } from "lucide-react";
import { toast } from "sonner";

export default function TemplatesView({ templates }) {
  const [active, setActive] = useState(0);
  const t = templates[active];
  if (!t) return null;
  const copy = async () => {
    await navigator.clipboard.writeText(`Subject: ${t.subject}\n\n${t.body.replace(/^Subject:.*\n\n/, "")}`);
    toast.success("Template copied");
  };
  return (
    <div className="grid lg:grid-cols-[320px_1fr] gap-5" data-testid="templates-view">
      <ul className="space-y-2">
        {templates.map((x, i) => (
          <li key={x.id}>
            <button onClick={() => setActive(i)} className="w-full text-left p-4 rounded-xl border" data-testid={`template-item-${x.id}`}
              style={{ background: i === active ? "var(--surface-2)" : "var(--surface)", borderColor: i === active ? "var(--amber)" : "var(--border)", transition: "border-color 160ms ease, background-color 160ms ease" }}>
              <div className="text-sm font-semibold">{x.title}</div>
              <div className="mono text-[11px] mt-1" style={{ color: "var(--text-2)" }}>{x.when}</div>
            </button>
          </li>
        ))}
      </ul>
      <section className="card p-5">
        <div className="flex items-start justify-between gap-3 mb-3">
          <div>
            <div className="eyebrow">{t.audience}</div>
            <h2 className="text-xl font-extrabold mt-1" data-testid="template-title">{t.title}</h2>
          </div>
          <button className="btn btn-amber btn-sm" onClick={copy} data-testid="copy-template-button"><Copy size={13} /> Copy</button>
        </div>
        <div className="p-4 rounded-xl mb-3 text-sm" style={{ background: "rgba(6,182,212,0.08)", border: "1px solid rgba(6,182,212,0.25)", color: "#a5f3fc" }}>{t.notes}</div>
        <pre className="pre p-4 rounded-xl" style={{ background: "var(--surface-2)" }} data-testid="template-body">{t.body}</pre>
      </section>
    </div>
  );
}
